module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/default-f5b9d448124583ac912dc928ae14293c.svg&quot;;"